var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.none.length === 0)?_c('div',{class:_vm.$style.center},[_vm._v("\n    没有消息？看看已读消息吧！\n  ")]):_c('div',_vm._l((_vm.none),function(item,index){return _c('x-topic',{key:index,attrs:{"topic":item}})}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0df5d12c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Message/NoneRead.vue
// module id = 363
// module chunks = 13